// Main page content
const main = {
  // Page title and description
  pageTitle: "Address Completion",
  pageDescription:
    "Support fuzzy matching of beginning and end, more data provided, more accurate search",

  // Form labels
  addressStartLabel: "Address Start",
  addressEndLabel: "Address End",

  // Form placeholders
  addressStartPlaceholder:
    "Please enter at least 4 starting characters of the address (required)",
  addressEndPlaceholder:
    "Please enter the ending characters of the address (optional)",

  // Buttons
  queryButton: "Query",
  resetButton: "Reset",

  // Status messages
  loadingText: "Loading...",
  noDataText: "No data",
  emptyPrompt: "Please enter the beginning or end of the address to query",

  // Result display
  addressLabel: "Address",

  // Validation messages
  addressStartRequired: "Please enter the starting address",

  // Notification messages
  copySuccess: "Copied successfully!",
  notificationTitle: "Notification",
  noResultsFound: "Sorry, no relevant data found in the query results",

  // Address inflow dialog
  inflowDialog: {
    title: "Address Inflow Transaction Overview",
    totalData: "Total",
    dataUnit: "records",
    download: "Download",
    loadingText: "Loading...",
    selectAddressFirst: "Please select an address first",
    queryInflow: "Query Address Inflow",
    dataLabel: "Data",
    dataCount: "records",
    tagLabel: "Tag",
    blockchainLabel: "Blockchain",
    addressLabel: "Address",
    defaultHeaders: {
      address: "Address",
      tokenTotalInflow: "Total Inflow (USDT)",
      mainCoinTotalInflow: "Total Inflow (Main Coin)",
    },
  },
};

// Hash completion page content
const hashCompletion = {
  // Page title and description
  hashPageTitle: "Hash Completion",
  hashPageDescription:
    "Support fuzzy matching of beginning and end, more data provided, more accurate search",

  // Form labels
  hashStartLabel: "Hash Start",
  hashEndLabel: "Hash End",

  // Form placeholders
  hashStartPlaceholder:
    "Please enter the starting characters of the hash (required)",
  hashEndPlaceholder:
    "Please enter the ending characters of the hash (optional)",

  // Buttons
  hashQueryButton: "Query",
  hashResetButton: "Reset",

  // Status messages
  hashLoadingText: "Loading...",
  hashNoDataText: "No data",
  hashEmptyPrompt: "Please enter the beginning or end of the hash to query",

  // Result display
  hashLabel: "Hash",

  // Validation messages
  hashStartRequired: "Please enter the starting hash",

  // Notification messages
  hashCopySuccess: "Copied successfully!",
  hashNotificationTitle: "Notification",
  hashNoResultsFound: "Sorry, no relevant data found in the query results",
};

export default {
  ...main,
  ...hashCompletion,

  // Sub-modules
};
